// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ProjectLinkAccessVO')
export class ProjectLinkAccessVO {

  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('guid', 'String')
  public guid: string = undefined;

  @JsonProperty('projectId', 'Number')
  public projectId: number = undefined;

  @JsonProperty('projectVersion', 'Number')
  public projectVersion: number = undefined;

  @JsonProperty('validDays', 'Number')
  public validDays: number = undefined;
}
